import React from "react";
import { default as PendingRequests } from "components/Dashboard/Dashboard_PendingRequests"
import { WIDGET_NAMES } from "components/WidgetTemplates/utils";
import { useTranslation } from "react-i18next";

const Card_PendingRequests = (props) => {
	// console.log(props);
	const { t } = useTranslation();

	return (
		<article className="card card-pending-absences">
			<div className="card-top">
				<h2>{t(WIDGET_NAMES[props.name])}</h2>
			</div>
			<div className="card-content">
				<PendingRequests />
			</div>
		</article>
	);
};

export default Card_PendingRequests;